import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import Link from "@tiptap/extension-link";
import Placeholder from "@tiptap/extension-placeholder";
import Highlight from "@tiptap/extension-highlight";
import TextAlign from "@tiptap/extension-text-align";
import TextStyle from "@tiptap/extension-text-style";
import Color from "@tiptap/extension-color";
import Image from "@tiptap/extension-image";
import Mention from "@tiptap/extension-mention";

import { EntityLink } from "./EntityLink";
import { getEntitySuggestion } from "./EntityLink";

export const getBaseExtensions = ({ placeholder = "" } = {}) => [
  StarterKit,
  Underline,
  Link.configure({ openOnClick: false }),
  Placeholder.configure({ placeholder }),
  Highlight,
  TextAlign.configure({ types: ["heading", "paragraph"] }),
  TextStyle,
  Color,
  Image,
  EntityLink.configure({ suggestion: getEntitySuggestion() }),
];

export const getCompactExtensions = ({
  placeholder = "",
  mentionSuggestion,
} = {}) => [
  StarterKit.configure({ heading: false }),
  Underline,
  Link.configure({ openOnClick: false }),
  Placeholder.configure({ placeholder }),
  EntityLink.configure({ suggestion: getEntitySuggestion() }),
  ...(mentionSuggestion
    ? [Mention.configure({ suggestion: mentionSuggestion })]
    : []),
];

// Re-exports for CommentBody rendering
export { StarterKit, Underline, Link, Highlight, TextAlign, TextStyle, Color, Image, Mention, EntityLink };
